class Configs {

    public static ENABLE_LOG: boolean = true;
    public static COLORED_LOG: boolean = true;

    public static DEV_HOST: string = `localhost`;
    public static DEV_USE_SSL: boolean = false;
    public static DEV_PORT: number = 9000;

    public static PROD_HOST: string = `pama.nightspade.com`;
    public static PROD_USE_SSL: boolean = false;
    public static PROD_PORT: number = 9000;

    public static AUTO_VERIFY_ACCOUNT: boolean = true;

    public static TOKEN_LIFETIME: number = 3600; // 3600 seconds expiration time 

    public static STORAGE_PREFIX: string = `42_L.p@959x-6Ue`;

    public static get DEV_URL(): string {
        return (this.DEV_USE_SSL ? `https` : `http`) +
            `://` +
            `${this.DEV_HOST}` +
            `:` +
            `${this.DEV_PORT}`;
    }

    public static get PROD_URL(): string {
        // return (this.PROD_USE_SSL ? `https` : `http`) +
        //     `://` +
        //     `${this.PROD_HOST}` +
        //     `:` +
        //     `${this.PROD_PORT}`;
        return `https` +
            `://` +
            `${this.PROD_HOST}`;
    }
}


export default Configs;